<template>
    <DataTable
        :header="$t('widgeterShops.shopsList')"
        :fields="fields"
        :items="parentComponent.items"
        :loading="parentComponent.loading"
        :error="parentComponent.error"
        :total-rows="parentComponent.requestData.max"
        :current-page.sync="parentComponent.tableParams.page"
        :per-page.sync="parentComponent.tableParams.perPage"
        :sort-by.sync="parentComponent.tableParams.sort"
        :sort-direction.sync="parentComponent.tableParams.order"
        no-local-sorting
    >
        <template #cell(shop)="{ item }">
            <a :href="item.url">
                <ImageLoader :src="item.logo" alt="" width="75px" height="39px" />
            </a>
        </template>
        <template #cell(category)="{ item }">
            <ul class="m-0 pl-3">
                <li v-for="category in item.categories" :key="category.id">
                    {{ category.name }}
                </li>
            </ul>
        </template>
        <template #cell(commissions)="{ item }">
            {{ item.commission }}
            <ul class="m-0 pl-3">
                <li v-for="(commission, index) in formatCommissions(item.commissions)" :key="index">
                    {{ commission }}
                </li>
            </ul>
        </template>
        <template #cell(textLinks)="{ item }">
            <BadgeBoolean :value="item.allowTextLinks" />
        </template>
        <template #cell(productFeed)="{ item }">
            <ButtonIcon
                v-if="item.feeds && item.feeds.length > 0"
                class="feed-btn"
                variant="primary"
                icon="list"
                short
                size="sm"
                @click="onShowFeeds(item.feeds)"
            >
                {{ $t('widgeterShops.showFeeds') }}
            </ButtonIcon>
        </template>
        <template #cell(status)="{ item }">
            <BadgeCampaignSpaceStatus :status="item.status" />
        </template>
        <template #cell(cookieExpireDays)="{ item }">
            {{ item.cookieExpireDays ? $tc('widgeterShops.transactionDetectTimeInDays', item.cookieExpireDays) : '-' }}
        </template>
    </DataTable>
</template>



<script>
    import DataTable from '@/components/common/DataTable.vue';
    import BadgeBoolean from '@/components/common/BadgeBoolean.vue';
    import BadgeCampaignSpaceStatus from '@/components/common/BadgeCampaignSpaceStatus.vue';
    import ImageLoader from '@/components/common/ImageLoader.vue';

    export default {
        name: 'Results',
        components: {
            DataTable,
            BadgeBoolean,
            BadgeCampaignSpaceStatus,
            ImageLoader,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {};
        },
        computed: {
            fields() {
                return [
                    { key: 'id', label: this.$t('widgeterShops.id') },
                    { key: 'shop', label: this.$t('widgeterShops.shop') },
                    { key: 'category', label: this.$t('widgeterShops.category') },
                    { key: 'commissions', label: this.$t('widgeterShops.commission') },
                    { key: 'textLinks', label: this.$t('widgeterShops.textLinks') },
                    { key: 'cookieExpireDays', label: this.$t('widgeterShops.transactionDetectTime') },
                    { key: 'productFeed', label: this.$t('widgeterShops.productFeed') },
                    { key: 'status', label: this.$t('widgeterShops.status') },
                ];
            },
        },
        methods: {
            onShowFeeds(feeds) {
                this.$root.$emit('bv::show::modal', 'modal-product-feeds');
                this.$root.$emit('show-product-feeds', feeds);
            },
            formatCommissions(commissions) {
                if (!commissions) {
                    return [];
                }
                return commissions
                    .filter(item => item.commission)
                    .map(item => {
                        let formatter = v => v;
                        switch (item.type) {
                            case 'amount':
                                formatter = this.$format.currency;
                                break;
                            case 'percent':
                                formatter = this.$format.percent;
                                break;
                            default:
                                formatter = this.$format.number;
                        }
                        return `${this.$t('widgeterShops.cps')} ${formatter(item.commission)}${item.description ? ` ${item.description}` : ''}`;
                    });
            },
        },
    };
</script>
